const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const PackSummeryReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_PACK_SUMMERY_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_PACK_SUMMERY_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_PACK_SUMMERY_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      case "CLEAR_PACK_SUMMERY":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default PackSummeryReducer;